<template>
  <div class="px-5">
    <div class="text-black text-2xl mt-10">
      <div class="flex items-center justify-between">
        <div class="my-3 fs-22 font-bold text-black">{{ $t('api_keys.title') }}</div>
      </div>
    </div>

    <div class="table-responsive">
      <div class="bg-white rounded-3xl p-3">
  <div v-if="!hasKeys && !createdSecret" class="p-2 rounded-xl mb-4">
          <div class="d-flex">
            <div class="ml-auto" style="width:33%">
              <div class="d-flex align-items-start">
                <div style="flex:1">
                  <input v-model="newKeyName" type="text" class="w-full form-control border bg-white rounded-md border-grey-300 p-2 px-3 py-2" :placeholder="$t('api_keys.key_name')" />
                  <p v-if="nameError" class="my-1 fs-10 text-danger">{{ nameError }}</p>
                </div>
                <button @click="createKey" type="button" class="flex items-center ml-3 bg-blue-700 text-white rounded-md h-10 px-3 border-0 focus:outline-none">
                  <span class="mr-2" style="font-weight:600; font-size:18px; line-height:1;">+</span>
                  <span class="font-medium">{{ $t('api_keys.create') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="createdSecret" class="mb-4">
          <div class="border p-3 rounded-xl bg-white" style="position:relative">
            <button type="button" class="icon-only" style="position:absolute; right:8px; top:8px;" @click="createdSecret = null" :title="$t('lbl_close') || 'Close'" aria-label="Close">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="fw-600 mb-2">{{ $t('api_keys.credentials_one_time') }}</div>
            <div class="mb-2">
              <div class="d-flex items-center justify-content-between mb-2">
                <div><strong>{{ $t('api_keys.api_key') }}:</strong> <code class="ml-2">{{ createdSecret.api_key }}</code></div>
                <div>
                  <button class="icon-only icon-primary" @click="copy(createdSecret.api_key)" :title="$t('api_keys.copy_key') || $t('lbl_copy') || 'Copy'" aria-label="Copy">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3939 8.15283H17.6034C19.5251 8.15283 21.1818 9.71522 21.1818 11.6436V21.6723C21.1818 23.7094 19.6334 25.3335 17.6034 25.3335H10.147C8.22429 25.3335 6.66656 23.6017 6.66656 21.6723V13.0918L11.3939 8.15283Z" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.6391 8.1416V10.8648C11.6391 12.1941 10.5667 13.2725 9.2423 13.2753C8.0131 13.2781 6.7559 13.2791 6.67096 13.2734" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.8164 20.1311H16.8536" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.7219 15.4949H16.8541" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.1333 6.73719V6.73719C14.1333 5.96168 14.762 5.33301 15.5375 5.33301H23.4155C24.4747 5.33301 25.3333 6.19162 25.3333 7.25078V19.3294C25.3333 20.3885 24.4747 21.2471 23.4155 21.2471H23" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="d-flex items-center justify-content-between">
                <div><strong>{{ $t('api_keys.api_secret') }}:</strong> <code class="ml-2">{{ createdSecret.api_secret }}</code></div>
                <div>
                  <button class="icon-only icon-primary" @click="copy(createdSecret.api_secret)" :title="$t('api_keys.copy_secret') || $t('lbl_copy') || 'Copy'" aria-label="Copy">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3939 8.15283H17.6034C19.5251 8.15283 21.1818 9.71522 21.1818 11.6436V21.6723C21.1818 23.7094 19.6334 25.3335 17.6034 25.3335H10.147C8.22429 25.3335 6.66656 23.6017 6.66656 21.6723V13.0918L11.3939 8.15283Z" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.6391 8.1416V10.8648C11.6391 12.1941 10.5667 13.2725 9.2423 13.2753C8.0131 13.2781 6.7559 13.2791 6.67096 13.2734" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.8164 20.1311H16.8536" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.7219 15.4949H16.8541" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.1333 6.73719V6.73719C14.1333 5.96168 14.762 5.33301 15.5375 5.33301H23.4155C24.4747 5.33301 25.3333 6.19162 25.3333 7.25078V19.3294C25.3333 20.3885 24.4747 21.2471 23.4155 21.2471H23" stroke="currentColor" stroke-width="1.43833" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="text-muted small">{{ $t('api_keys.secret_shown_once_note') }}</div>
          </div>
        </div>

        <div v-if="loading" class="text-center py-6">{{ $t('lbl_loading') || 'Loading...' }}</div>

        <div v-if="!loading">
          <div class="fs-20 fw-600 row p-6 border-bottom border-gray-700 mb-6 pb-3">
            <div class="txt-grey-1000 col-6">{{ $t('api_keys.name') || $t('lbl_name') || 'Name' }}</div>
            <div class="txt-grey-1000 col-4">{{ $t('api_keys.created_at') || 'Created at' }}</div>
            <div class="col-2 text-right">{{ $t('api_keys.actions') || '' }}</div>
          </div>

          <div>
            <div v-if="hasKeys">
              <div v-for="(item, index) in keys" :key="item.id || index" class="cursor-pointer mb-2 radius-10 bg-blue-gray row p-6 fs-16 fw-400 txt-grey-900">
                <div class="fw-700 col-6">{{ item.name || (item.description || '-') }}</div>
                <div class="col-4">{{ item.created_at || item.createdAt || '' }}</div>
                <div class="col-2 text-right">
                  <button class="icon-only icon-danger" @click="confirmDelete(item)" :title="$t('api_keys.delete') || $t('lbl_delete') || 'Delete'" aria-label="Delete">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18.8499 9.13989L18.1999 19.2099C18.0899 20.7799 17.9999 21.9999 15.2099 21.9999H8.7899C5.9999 21.9999 5.9099 20.7799 5.7999 19.2099L5.1499 9.13989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10.3301 16.5H13.6601" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.5 12.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="text-center text-muted py-6">{{ $t('api_keys.no_api_keys') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonHoDo } from '@/components/Button'

export default {
  name: 'OrganizationApiKeys',
  components: { ButtonHoDo },
  props: {
    orgId: {
      type: [Number, String],
      required: false
    }
  },
  data () {
    return {
      keys: [],
      loading: false,
      createdSecret: null,
      newKeyName: '',
      nameError: ''
    }
  },
  mounted () {
    this.fetchKeys()
  },
  computed: {
    hasKeys () {
      return Array.isArray(this.keys) && this.keys.length > 0
    }
  },
  methods: {
    async fetchKeys () {
      const id = this.orgId || this.$globalOrg?.id
      if (!id) return
      this.loading = true
      try {
        const res = await this.$rf.getRequest('AdminRequest').getOrgAPIKey(id)
        // backend may return an array or a single object
        const d = res.data
        if (Array.isArray(d)) this.keys = d
        else if (d && typeof d === 'object') this.keys = d.name ? [d] : (d.data && Array.isArray(d.data) ? d.data : (d.data ? [d.data] : []))
        else this.keys = []
      } catch (err) {
        console.error(err)
        this.$toast && this.$toast.open({ message: this.$t('lbl_api_error_status') || 'An error occurs when update status. Please try another time.', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    async createKey () {
      const id = this.orgId || this.$globalOrg?.id
      if (!id) return
      // disallow creating if a key already exists for this organization
      if (this.hasKeys) {
        this.$toast && this.$toast.open({ message: this.$t('api_keys.already_exists') || 'An API key already exists for this organization', type: 'warning' })
        return
      }
      if (!this.newKeyName || !this.newKeyName.trim()) {
        this.nameError = this.$t('api_keys.key_name_required') || 'Key name is required'
        return
      }
      this.nameError = ''
      try {
        const payload = { org_id: id, name: this.newKeyName }
        const res = await this.$rf.getRequest('AdminRequest').createOrgAPIKey(payload)
        const data = res.data?.data || res.data
        if (data) {
          this.createdSecret = data
          this.fetchKeys()
          this.newKeyName = ''
        }
      } catch (err) {
        console.error(err)
        this.$toast && this.$toast.open({ message: this.$t('lbl_api_error_status') || 'An error occurs when update status. Please try another time.', type: 'error' })
      }
    },
    copy (text) {
      if (!text) return
      navigator.clipboard && navigator.clipboard.writeText(text).then(() => {
        this.$toast && this.$toast.open({ message: this.$t('lbl_copied_clipboard') || 'Copied', type: 'success' })
      })
    },
    confirmDelete (item) {
      const orgId = this.orgId || this.$globalOrg?.id
      if (!orgId) {
        this.$toast && this.$toast.open({ message: this.$t('lbl_api_error_status') || 'Unable to determine organization id to delete key', type: 'error' })
        return
      }
      if (!confirm(this.$t('api_keys.delete_confirm'))) return
      this.deleteKey(orgId)
    },
    async deleteKey (id) {
      try {
        await this.$rf.getRequest('AdminRequest').deleteOrgAPIKey(id)
        // hide one-time credentials panel when deleting
        this.createdSecret = null
        this.$toast && this.$toast.open({ message: this.$t('api_keys.deleted') || 'Deleted', type: 'success' })
        this.fetchKeys()
      } catch (err) {
        console.error(err)
        this.$toast && this.$toast.open({ message: this.$t('lbl_api_error_status') || 'An error occurs when update status. Please try another time.', type: 'error' })
      }
    }
  }
}
</script>

<style scoped>
.btn-sm {padding: .25rem .5rem;font-size:.8rem}
.alert code {background:#f3f4f6;padding:.15rem .4rem;border-radius:4px}

.icon-only {
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  line-height: 1;
  cursor: pointer;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.icon-only:focus { outline: none; }
.icon-primary { color: #0369a1; }
.icon-danger { color: #dc2626; }

.icon-only img { width: 20px; height: 20px; display: block; }
.icon-primary img { filter: none; }
.icon-danger img { filter: none; }

/* Inline SVG sizing + inherit color */
.icon-only svg { width: 20px; height: 20px; display: block; }
.icon-primary svg { color: #0369a1; }
.icon-danger svg { color: #dc2626; }

</style>
